import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  root: {
    padding: 0,

    '& .MuiPaper-root': {
      width: '100%',
    },
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing(20),
    padding: spacing(40),
    minHeight: spacing(50),
  },
  warrantyMonthsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing(10),
  },
  label: {
    fontSize: spacing(14),
    lineHeight: spacing(20),
    fontWeight: 500,
    color: Theme.Colors.Grayscale.SixtyFour,
  },
  required: {
    marginLeft: spacing(5),
    color: Theme.Colors.Red.Base,
    fontSize: spacing(16),
  },
}))
